import { AttributeDTO } from '../attribute/types';
import { LibsValueSchemaDTO } from '../value-schema';
import { z } from 'zod/v4';

export const CILinkAttributeParserResponseDTO = z.object({
  ci_type_link_id: z.string().uuid(),
  attribute_id: z.string().uuid(),
  parser_name: z.string(),
  arguments: z.record(z.string(), z.any()),
});
export type CILinkAttributeParserResponse = z.infer<
  typeof CILinkAttributeParserResponseDTO
>;

export const CILinkAttributeParserTestRequestDTO = z.object({
  attribute_id: z.uuid(),
  ci_type_link_id: z.uuid(),
  ci_id: z.uuid().optional(),
  raw_config: z.string().optional(),
});
export type CILinkAttributeParserTestRequest = z.infer<
  typeof CILinkAttributeParserTestRequestDTO
>;

export const CILinkAttributeUpdateRequestDTO = z.object({
  parser_class_name: z.string(),
  arguments: z.record(z.string(), z.any()),
});
export type CILinkAttributeUpdateRequest = z.infer<
  typeof CILinkAttributeUpdateRequestDTO
>;

export const CILinkAttributeValueDTO = z.object({
  attribute_id: z.uuid(),
  value_id: z.uuid().optional(),
  value: z.any().optional(),
});
export type CILinkAttributeValue = z.infer<typeof CILinkAttributeValueDTO>;

export const CILinkAttributeValueSchemaDTO = z.object({
  attribute: AttributeDTO,
  attribute_value: LibsValueSchemaDTO,
  // planned_value: LibsValueSchemaDTO.optional(), // uncomment if needed
});
export type CILinkAttributeValueSchema = z.infer<
  typeof CILinkAttributeValueSchemaDTO
>;